import { render } from "./loadingLogo.vue?vue&type=template&id=7e84bd85"
import script from "./loadingLogo.vue?vue&type=script&lang=js"
export * from "./loadingLogo.vue?vue&type=script&lang=js"

import "./loadingLogo.vue?vue&type=style&index=0&id=7e84bd85&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__